import Link from 'next/link'

const ContactLink = ({ link, children, ...args }) => {
  return (
    <Link
      scroll={false}
      href={link}
      {...args}
      className="custom-underline relative group w-fit text-bodyMobile md:text-bodyDesktop text-background font-chivoMono transition-all duration-500"
    >
      {children}
    </Link>
  )
}

export default ContactLink
